import clsx from 'clsx';

import type { BaseComponentProps } from '@coursera/cds-common';

import getLogoWrapperCss, { classes } from './getLogoWrapperCss';

export type Props = {
  /**
   * The logo content to wrap. This can be an image, SVG, or any other React element.
   */
  children: React.ReactNode;

  /**
   * The size of the logo wrapper.
   * @default medium
   */
  size?: 'small' | 'medium';
} & BaseComponentProps<'div'>;

/**
 * A wrapper component that adds a white background and padding to logos in dark mode.
 * This is useful for logos that don't have proper contrast on dark backgrounds.
 *
 * See [Props](__storybookUrl__/components-data-display-logowrapper--default#props)
 */
const LogoWrapper = (props: Props) => {
  const { size = 'medium', children, className, ...rest } = props;

  return (
    <div
      className={clsx(className, classes.base, {
        [classes.medium]: size === 'medium',
      })}
      css={getLogoWrapperCss()}
      {...rest}
    >
      {children}
    </div>
  );
};

export default LogoWrapper;
